import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { InputComponent } from './input/input.component';
import { InputDateComponent } from './input-date/input-date.component';
import { TranslateModule } from '@ngx-translate/core';
import { AppPipesModule } from '../../pipes/app-pipes/app-pipes.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {InputDatetimeComponent} from './input-datetime/input-datetime.component';
import {MatInputModule} from '@angular/material/input';
import {NgxMatDatetimePickerModule} from '@angular-material-components/datetime-picker';

@NgModule({
  declarations: [
    InputComponent,
    InputDateComponent,
    InputDatetimeComponent
  ],
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule,
        MatDatepickerModule,

        // pipes
        AppPipesModule,
        MatInputModule,
        NgxMatDatetimePickerModule
    ],
  exports: [
    InputComponent,
    InputDateComponent,
    InputDatetimeComponent
  ]
})
export class InputModule {}
